import { Message } from "@apis:message/message";
import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";

interface SearchStore {
  question: string;
  answer: string;
  llmQuestion: string;
  references: Message["GET_ONE"]["Response"]["docs"];
  actions: {
    setQuestion: (value: string) => void;
    setAnswer: (value: string | ((prev: string) => string)) => void;
    setLLMQuestion: (value: string) => void;
    setReferences: (value: Message["GET_ONE"]["Response"]["docs"]) => void;
    reset: () => void;
    resetAnswer: () => void;
  };
}

const useSearchStore = create<SearchStore>((set) => ({
  question: "",
  answer: "",
  llmQuestion: "",
  references: [],
  actions: {
    setQuestion: (question) => set({ question }),
    setAnswer: (answer) => {
      if (typeof answer === "function") {
        set((state) => ({ answer: answer(state.answer) }));
      } else {
        set({ answer });
      }
    },
    setLLMQuestion: (llmQuestion) => set({ llmQuestion }),
    setReferences: (references) => set({ references }),
    reset: () =>
      set({
        question: "",
        answer: "",
        llmQuestion: "",
        references: [],
      }),
    resetAnswer: () =>
      set({
        answer: "",
        llmQuestion: "",
        references: [],
      }),
  },
}));

export const useSearchActions = () => useSearchStore((state) => state.actions);

export const useSearchData = () =>
  useSearchStore(
    useShallow((state) => ({
      question: state.question,
      answer: state.answer,
      llmQuestion: state.llmQuestion,
      references: state.references,
    })),
  );
